import type { ReactNode } from "react";

import { StyledInnerWrapper, StyledPage } from "./styles";

type Props = {
    children: ReactNode;
};

const ManageIntentSignalsPage = (props: Props) => {
    return (
        <StyledPage>
            <StyledInnerWrapper>{props.children}</StyledInnerWrapper>
        </StyledPage>
    );
};

export default ManageIntentSignalsPage;
